import React from "react";
import i18n from "i18next";
import EnrichedPDFPlugin from "../components/EnrichedPDFPlugin.js";

// PDF.js v3.x with React 19 compatibility
let pdflib = null;
let pdfSupported = true;

try {
  pdflib = require("pdfjs-dist");

  // Configure worker for PDF.js v3.x
  if (pdflib.GlobalWorkerOptions) {
    const isOfflineContext =
      typeof window !== "undefined" &&
      (window.location.protocol === "file:" || (typeof State !== "undefined" && State));

    if (isOfflineContext) {
      pdflib.GlobalWorkerOptions.workerSrc = "images/pdf.worker.min.js";
    } else {
      pdflib.GlobalWorkerOptions.workerSrc =
        "https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js";
    }
  }

  console.log("EnrichedPDF visor loaded successfully");
} catch (error) {
  console.error("PDF.js could not be loaded:", error);
  pdfSupported = false;
}

import "../EnrichedPDF.scss";

export function EnrichedPDF(base) {
  return {
    getRenderTemplate: function (state, props) {
      return (
        <div className="pdfViewerPlugin" style={{ height: "100%", width: "100%" }}>
          <EnrichedPDFPlugin
            style={{ width: "100%", height: "100%" }}
            base={base}
            props={props}
            state={state}
          />
        </div>
      );
    },
  };
}
